import { RootState } from "../../store";

export const isAccountSetupDialogOpenSelector = (state: RootState): boolean =>
  state.accountSetup.dialogOpen;
